import React, { FC } from 'react';
import { buttonClasses } from '@mui/material';

import { Button2, Button2Props } from '../Button2';
import { SettingsAlt24 } from '../../icons';
import { Counter } from '../Counter';


export type FilterButtonProps = Button2Props & {
    isOpen?: boolean;
    activeCount?: number;
}

export const FilterButton: FC<FilterButtonProps> = ({ activeCount, isOpen, ...buttonProps }) => (
    <Button2
        variant='stroke'
        size='small'
        startIcon={<SettingsAlt24 />}
        endIcon={activeCount > 0 && <Counter variant='primary' active={isOpen} count={activeCount} />}
        disableRipple
        sx={{
            [`.${buttonClasses.endIcon} > *:nth-of-type(1)`]: {
                fontSize: '1.2rem',
            },
            ...isOpen && {
                bgcolor: 'grayscale.shade40',
            },
        }}
        {...buttonProps}
    />
);
